import { DeleteAction, EditAction } from "@/components/Action";
import StatusComponent from "@/components/Status";
import { DATE_FORMAT, UserStatus } from "@/constants/default";
import { usePermissions } from "@/rbac";
import { permissions } from "@/rbac/permissions";
import { BusinessUnit } from "@/types/businessunit.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function TableHeader(): ColumnDef<BusinessUnit>[] {
    const {t} = useTranslation();
    const { hasPermission } = usePermissions();
    const navigate = useNavigate()
    const location = useLocation()

    return [
        {
            header: t("businessunit.name"),
            accessorKey: "name"
        },
        {
            header: t("businessunit.account"),
            accessorKey: "account",
            enableSorting: false
        },
        {
            header: t("businessunit.door_pin"),
            accessorKey: "door_pin",
            enableSorting: false
        },
        {
            header: t("businessunit.condo_card"),
            accessorKey: "condo_card",
            enableSorting: false
        },
        {
            header: t("businessunit.landlord_name"),
            accessorKey: "landlord_name",
            enableSorting: false
        },
        {
            header: t("businessunit.address"),
            accessorKey: "address",
            enableSorting: false
        },
        {
            header: t("businessunit.condo"),
            accessorKey: "condo",
            enableSorting: false
        },
        {
            header: t("businessunit.unit"),
            accessorKey: "unit",
            enableSorting: false
        },
        {
            header: t("dashboard.total_rooms"),
            accessorKey: "rooms",
            enableSorting: false,
            cell: ({row}) => row.original.rooms?.length || 0
        },
        {
            header: t("table.status"),
            accessorKey: "status",
            enableSorting: false,
            cell: ({ row }) => <StatusComponent status={row.original.status} title={UserStatus(row.original.status)} />
        },
        {
            header: t("table.created_at"),
            accessorKey: "created_at",
            cell: ({ row }) => formatDateTimeAutoToString(row.original.created_at ?? '', DATE_FORMAT)
        },
        {
            header: t("table.action"),
            accessorKey: "action",
            enableSorting: false,
            cell: ({ row }) => (
                <div className="flex items-center space-x-3.5">
                    {
                        hasPermission(permissions.BUSINESSUNITS.EDIT) && <EditAction onClick={() => navigate(location , {state: {modal: "/settings/business-units/edit", id: row.original.id}})} />
                    }
                    {
                        hasPermission(permissions.BUSINESSUNITS.DELETE) && <DeleteAction onClick={() => navigate(location , {state: {modal: "/settings/business-units/delete", id: row.original.id}})} />
                    }
                </div>
            )
        }
    ]
}